import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import LeftSideLoginReg from "../elements/LeftSideLoginReg";
import LoginForm from "../forms/LoginForm";
import logoEu1 from "../../resources/eu-logo-1.png";
import logoEu2 from "../../resources/eu-logo-2.png";

const Login: React.FC<{}> = () => {
  const [searchParams] = useSearchParams();

  const emailQuery = useMemo(() => searchParams.get("email"), [searchParams]);

  return (
    <div className="flex flex-row min-h-screen">
      <LeftSideLoginReg />
      <div className="w-[calc(100%*5/9)] flex flex-col justify-center items-center">
        <div className="w-1/2 self-center">
          <h2 className="mb-4 text-3xl font-bold">Log in to your account</h2>
          <p className="mb-8 text-gray-500">
            Welcome back! Please enter your details.
          </p>
          <LoginForm email={emailQuery} />
          <div className="flex-row flex-wrap flex mt-5 justify-center">
            <img className="h-[50px] mb-3 " src={logoEu1} alt="Logo" />
            <img className="h-[50px] mb-3" src={logoEu2} alt="Logo" />
          </div>
          <p className="mt-2 text-gray-500 font-bold text-center">
            <p className="text-center">Програма:</p> "Конкурентоспособност и
            иновации в предприятията" 2021-2027
          </p>
          <p className="mt-2 text-gray-500 text-center">
            <p className="font-bold">Проект:</p> BG16RFPR001-1.003-0483-C01
          </p>
          <p className="mt-2 text-gray-500 text-center">
            Иновативна платформа за контрол и проследяване на строителния процес
          </p>
          <p className="mt-2 text-gray-400 text-center">
            <p className="font-bold text-center">Сериен номер:</p>{" "}
            SN-2512-9F27-XQ41-B8L2
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
